import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInfoService } from '@api/base-info.service';
import { BulkTypeResponseDataModel } from '@shared/model/bulk-type-response.model';
import { ContainersResponseData } from '@shared/model/containers-response.model';
import { QuoteExtraService } from '@shared/services/quote-extra-services.service';
import { Subject, Subscription } from 'rxjs';
import { QuotePersistService } from '../quote-persist.service';
import { CustomsModel } from '@shared/model/customs.model';
import { CustomsService } from '@shared/services/customs.service';

@Component({
  selector: 'app-quote-logistics-service-info',
  templateUrl: './quote-logistics-service-info.component.html',
  styleUrls: ['./quote-logistics-service-info.component.scss']
})
export class QuoteLogisticsServiceInfoComponent implements OnInit {
  @Output() output: EventEmitter<File> = new EventEmitter();
  public destroy$ = new Subject<void>();
  expressStatus = false;
  submit = false;
  minDate: Date;
  minDateToDate: Date;
  containerTypeId;
  containerCount;
  serviceTypeId;
  customs: CustomsModel[] = [];
  isDocument = false;
  destinationPort = false;
  formGroup: FormGroup;
  serviceType = [
    { labelFa: 'حمل و نقل', labelEn: 'Transportation', values: 0 },
    { labelFa: 'ترخیص', labelEn: 'Clearance', values: 1 },
    { labelFa: 'حمل و نقل و ترخیص', labelEn: 'Clearance and Transportation', values: 2 },
  ];
  bulkTypes: BulkTypeResponseDataModel[] = [];
  containersOptions: ContainersResponseData[] = [];
  private subscription: Subscription;
  constructor(
    public quoteExtra: QuoteExtraService,
    private formBuilder: FormBuilder,
    private quotePersistService: QuotePersistService,
    private baseInfoService: BaseInfoService,
    private stepper: MatStepper,
    public customsService: CustomsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.minDate = new Date();
    this.minDateToDate = new Date();
  }
  ngOnInit() {
    this.initialForm();
    this.getExpress();
    this.getDataSelectFields();
    this.patchFormWithCache();
    if (this.route.snapshot.queryParams.auth) {
      this.stepper.selectedIndex = 3;
    }
  }
  initialForm() {
    this.formGroup = this.formBuilder.group({
      serviceTypeId: [null, [Validators.required]],
      departureDate: [null, [Validators.required]],
      arriveDate: [null, [Validators.required]],
      isDocument: [false, []],
      isContainer: [true, []],
      containerTypeId: [null, []],
      containerLoadTypeId: [1, [Validators.required]],
      containerCount: [null, []],
      bulkTypeId: [null, []],
      containers: this.formBuilder.array([])
    });
  }

  addContainer() {
    this.containers.push(this.newConainers());
    this.formGroup.get('containerTypeId').reset();
    this.formGroup.get('containerCount').reset();
  }
  get containers(): FormArray {
    return this.formGroup.controls.containers as FormArray;
  }
  newConainers(): FormGroup {
    return this.formBuilder.group({
      containerTypeId: this.formGroup.value.containerTypeId,
      containerCount: this.formGroup.value.containerCount,
      faTitle: this.containersOptions[this.formGroup.value.containerTypeId - 1].faTitle
    });
  }
  removeContainer(i: number) {
    this.containers.removeAt(i);
  }
  getExpress() {
    const url = this.router.url;
    this.expressStatus = url.includes('express');
  }
  changeServiceType(serviceType) {
    this.quotePersistService.sendServiceTypeId(+this.formGroup.get('serviceTypeId').value);
  }

  getDataSelectFields() {
    this.subscription = this.quotePersistService.getQuoteRequestFields().subscribe(res => {
      this.containersOptions = res?.containers;
      this.bulkTypes = res?.bulkTypes;
    }
    );
  }
  patchFormWithCache() {
    if (!!this.quotePersistService.getFromLS('logistics-service-info')) {
      const {
        serviceTypeId,
        departureDate,
        arriveDate,
        isDocument,
        isContainer,
        containerTypeId,
        containerLoadTypeId,
        containerCount,
        bulkTypeId,
        switch: _switch,
      } = this.quotePersistService.getFromLS('logistics-service-info');
      const controls = this.formGroup.controls;
      controls.serviceTypeId.patchValue(serviceTypeId);
      controls.departureDate.patchValue(departureDate);
      controls.arriveDate.patchValue(arriveDate);
      controls.departureDate.patchValue(isDocument);
      controls.arriveDate.patchValue(isContainer);
      controls.serviceTypeId.patchValue(containerTypeId);
      controls.departureDate.patchValue(containerLoadTypeId);
      controls.arriveDate.patchValue(containerCount);
      controls.serviceTypeId.patchValue(bulkTypeId);
    }
  }
  dateMin(event) {
    this.minDateToDate = event.value._d;
  }

  saveToLs() {
    this.submit = true;
    this.formGroup.markAllAsTouched();
    this.customs = JSON.parse(localStorage.getItem('customs'));
    const lengthCustoms = this.customs?.length;
    if (this.customs[lengthCustoms - 1].portType?.id === 7) {
      this.destinationPort = true;
    }
    if (this.formGroup.valid && this.destinationPort) {
      const data = { ...this.formGroup.value };
      this.quotePersistService.saveToLS('logistics-service-info', data);
      if (this.destinationPort) {
        this.stepper.next();
      }
    }
        this.stepper.next();

  }
  checkBoxDocument(event) {
    if (event.detail.checked) {
      this.quoteExtra.sendDocument(event.detail.checked);
    }
  }
  changeContainer(event) {
    if (event.detail.checked) {
      this.formGroup.get('bulkTypeId').reset();
    }
    if (!event.detail.checked) {
      this.formGroup.get('containerTypeId').reset();
      this.formGroup.get('containerCount').reset();
    }
  }
  ngOnDestroy() {
    this.formGroup.reset();
  }
}
